import './FeaturedResults.css';
import useTilt from '../useTilt';

const metrics = [
  { value: '3.2×', label: 'Avg. Enquiry Increase' },
  { value: '48hr', label: 'Campaign Go-Live' },
  { value: '90+', label: 'Google Rating Growth' },
  { value: '15K+', label: 'Ad Reach / Month' },
];

export default function FeaturedResults() {
  const tilt = useTilt(4);
  return (
    <section id="featured-results" className="fr-section">
      <div
        className="fr-card reveal"
        ref={tilt.ref}
        onMouseMove={tilt.onMouseMove}
        onMouseLeave={tilt.onMouseLeave}
      >
        <div className="fr-left">
          <span className="section-label">Featured Result</span>
          <h2 className="section-title">Local brand. <em>Real growth.</em></h2>
          <p className="section-sub">
            A Trichy-based retail client came to us with zero online presence. In under 4 months —
            a live website, active Google Business profile, and running Meta Ads campaigns turned
            walk-in-only footfall into a steady stream of online enquiries.
          </p>
          <a href="#/portfolio" className="btn-primary fr-cta">View Portfolio →</a>
        </div>
        <div className="fr-right">
          {metrics.map(m => (
            <div key={m.label} className="fr-metric">
              <span className="fr-value">{m.value}</span>
              <span className="fr-label">{m.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
